/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Libraries
import styled from 'styled-components';

// Plugins
import { hexToRgba } from '../../plugins/general';

export const Container = styled.div`
  display: flex;
  cursor: pointer;
  width: 296px;
  border: 1px solid ${({ theme }) => theme.color.maintenanceCard.borderColor};
  background-color: ${({ theme }) => theme.color.maintenanceCard.backgroundColor};
  border-radius: 3px;
  flex-direction: column;

  &:hover {
    border: 1px solid ${({ theme }) => theme.color.machineCard.hoverBorderColor};
    box-shadow: 2px 2px 6px ${({
      theme,
    }) => hexToRgba(theme.color.machineCard.hoverShadowColor, 0.5)};
  };
      
  &:active {
    transform: scale(0.99);
  };
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  width: auto;
  justify-content: center;
  height: 120px;
`;

export const ParagraphContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  border-top: 1px solid ${({ theme }) => theme.color.maintenanceCard.dividerColor};
  background-color: ${({ theme }) => theme.color.maintenanceCard.paragraphBackgroundColor} !important;
  border-radius: 0 0 4px 4px;
  height: 60px;
  min-width: 0;
`;

export const TextContainer = styled.div`
  flex: 1;
  min-width: 0;
  width: 100%;
`;

export const ContentContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const Image = styled.img`
  width: 100%;
  height: 90%;
  object-fit: contain;
  object-position: center;
`;
